import { z } from "zod";

export const supplierInvoiceAmountValidation = z.object({
  charge_per_move_amount: z.number({
    error: "Charge per move is required",
  }),
});

export const supplierBookingFeeValidation = z.object({
  booking_fee_amount: z.number({ error: "Booking fee is required" }),
});
